import gql from 'graphql-tag'

export const deleteUserMutation = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId)
  }
`
